import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Link from 'next/link';
import ImgTheme from '../../common/ImgTheme';

import {AccountingHelper} from 'components/helpers/AccountingHelper';
import DropDownStyle from '../styles/header-profile-dropdown.module.scss'

export default ({setShowDropDown}) => {
    const {t} = useTranslation()
    const {info: UserInfo, plan: UserPlan} = useSelector((state) => state.User);

    const HideModal = () => {
        setShowDropDown(false)
    }

    const nameSimplifier = () => {
        let {first_name, last_name} = UserInfo;
        if (first_name && last_name) {
            return first_name[0] + ' ' + last_name[0]
        }

        return 'ا ه'
    }

    const RenderUserAlias = () => {
        return <Link href={'/profile'} as={'/profile'}>
            <a className={'flex flex-row gap-3 items-center p-[8px]'} onClick={HideModal}>
                <span className={DropDownStyle.drop_down__alias_simple}>{nameSimplifier()}</span>
                <div>
                    <h3 className={'text-[var(--text-color)] font-medium text-lg mb-0'}>{`${UserInfo.first_name} ${UserInfo.last_name}`}</h3>
                    <div className={'text-xs english-number'}>
                        <span className={'ml-1'}>UID:</span>
                        <span>{UserInfo.pk + 106879324}</span>
                    </div>
                </div>
            </a>
        </Link>
    }

    const RenderUserPlan = () => {
        return <Link href={'/profile'} as={'/profile'}>
            <a className={'flex flex-row justify-between w-full p-[8px] text-[var(--text-color)]'} onClick={HideModal}>
                <div className={'flex flex-row gap-2 items-center'}>
                    <ImgTheme src={'/images/icons/profile-plan.svg'}/>
                    {UserPlan.user_level}
                </div>
                {
                    UserPlan.order < AccountingHelper.LAST_PLAN &&
                    <div className={'text-xs bg-primary text-white py-1 px-2 rounded-[6px]'}>
                        {t('upgrade_plan')}
                    </div>
                }
            </a>
        </Link>
    }

    return <div className={DropDownStyle.drop_down}>
        <div className={DropDownStyle.drop_down__container}>
            <div className={`${DropDownStyle.drop_down__item}`}>
                <RenderUserAlias/>
            </div>
            <div className={`${DropDownStyle.drop_down__item}`}>
                <RenderUserPlan/>
            </div>
            <div className={`${DropDownStyle.drop_down__item} !border-b-0`}>
                <Link href={'/fee'} as={'/fee'}>
                    <a className={'p-[8px] text-[var(--text-color)]'} onClick={HideModal}>
                        <div className={'flex flex-row gap-2 items-center'}>
                            <ImgTheme src={'/images/icons/profile-trading-fee.svg'}/>
                            {t('fee_base_title')}
                        </div>
                    </a>
                </Link>
            </div>

            <div className={DropDownStyle.drop_down__divider}></div>

            <div className={`${DropDownStyle.drop_down__item}`}>
                <Link href={'/security'} as={'/security'}>
                    <a className={'p-[8px] text-[var(--text-color)]'} onClick={HideModal}>
                        <div className={'flex flex-row gap-2 items-center'}>
                            <ImgTheme src={'/images/icons/profile-security.svg'}/>
                            {t('security')}
                        </div>
                    </a>
                </Link>
            </div>
            <div className={`${DropDownStyle.drop_down__item} !border-b-0`}>
                <Link href={'/invite'} as={'/invite'}>
                    <a className={'p-[8px] text-[var(--text-color)]'} onClick={HideModal}>
                        <div className={'flex flex-row gap-2 items-center'}>
                            <ImgTheme src={'/images/icons/profile-invite.svg'}/>
                            {t('user_invite')}
                        </div>
                    </a>
                </Link>
            </div>

            <div className={DropDownStyle.drop_down__divider}></div>

            <div className={`${DropDownStyle.drop_down__item}`}>
                <Link href={'/logout'} as={'/logout'}>
                    <a className={'p-[8px] text-[var(--text-color)]'} onClick={HideModal}>
                        <div className={'flex flex-row gap-2 items-center'}>
                            <ImgTheme src={'/images/icons/profile-logout.svg'}/>
                            {t('logout')}
                        </div>
                    </a>
                </Link>
            </div>
        </div>
    </div>
}